"use client";

import { isServer, QueryClient } from "@tanstack/react-query";

let browserQueryClient: QueryClient | undefined;

function createClientQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}

export function getClientQueryClient() {
  if (isServer) {
    return createClientQueryClient();
  }

  browserQueryClient ??= createClientQueryClient();
  return browserQueryClient;
}

export function resetClientQueryClientForTest() {
  browserQueryClient?.clear();
  browserQueryClient = undefined;
}
